import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Row inside a Menu: icon, label, optional hotkey. tone danger for Discard.
 */
export interface MenuItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: string;
  iconColor?: string;
  kbd?: string;
  tone?: "default" | "danger" | "muted";
  children: React.ReactNode;
}

export function MenuItem({ icon, iconColor, kbd, tone = "default", className, children, ...rest }: MenuItemProps): JSX.Element {
  return (
    <button
      type="button"
      role="menuitem"
      className={["gk-menuitem", tone !== "default" && "gk-menuitem--" + tone, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {icon && <Icon name={icon} size={18} style={iconColor ? { color: iconColor } : undefined} />}
      <span>{children}</span>
      {kbd && <span className="gk-menuitem__kbd">{kbd}</span>}
    </button>
  );
}
